import Select from "./UI/Select";

export default Select;